import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=1a1d8986&scoped=true&"
import script from "./EditLink.vue?vue&type=script&lang=ts&"
export * from "./EditLink.vue?vue&type=script&lang=ts&"
import style0 from "./EditLink.vue?vue&type=style&index=0&id=1a1d8986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d8986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1d8986')) {
      api.createRecord('1a1d8986', component.options)
    } else {
      api.reload('1a1d8986', component.options)
    }
    module.hot.accept("./EditLink.vue?vue&type=template&id=1a1d8986&scoped=true&", function () {
      api.rerender('1a1d8986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/EditLink.vue"
export default component.exports